import React from "react";
import { getClassNames } from "../../../utils";
import withTheme from "../../../hocs/withTheme";

import "./TabPane.css";

const TabPane = (props) => {
    const {
        children = null,
        isActive = false,
        disabled = false,
        tabKey,
        className: classNameProp = null,
    } = props;

    const className = getClassNames(
        "TabPane",
        classNameProp,
        { "TabPane-active": isActive },
        { "TabPane-inactive": !isActive },
        { "TabPane-disabled": disabled }
    );

    return (
        <div
            key={tabKey}
            role="tab"
            aria-selected={isActive}
            aria-disabled={disabled}
            className={className}
        >
            {children}
        </div>
    );
};


export default withTheme(TabPane);
